var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('dashboard-core-app-bar',{on:{"logout":_vm.logout}}),_c('dashboard-core-drawer'),_c('dashboard-core-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }